// TEMP! used for calling it from old code

import { renderModalDialog } from 'reactApp/utils/createDialogToolkit';

import { OpenDocument } from './OpenDocument';

export const renderOpenDocument = renderModalDialog(OpenDocument, 'OpenDocument');
